import { SvgIcon } from "@mui/joy";
import { createSvgIcon } from "@mui/material";

export default function HighlightIndicator() {
  const LogoIcon = createSvgIcon(
    // <svg
    //   width="18"
    //   height="22"
    //   viewBox="0 0 18 22"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M8.70893 0.154608C8.74936 0.117731 8.76957 0.0992927 8.7882 0.0838744C8.79844 0.075399 8.82841 0.0521947 8.83917 0.0443969C8.85876 0.0302115 8.80494 0.0653506 8.82647 0.051295C8.93123 -0.017099 9.06874 -0.0170984 9.1735 0.0512972C9.19503 0.0653524 9.14121 0.0302144 9.1608 0.0443992C9.17157 0.0521967 9.20153 0.0754 9.21177 0.0838751C9.2304 0.0992927 9.25061 0.11773 9.29103 0.154605C9.76437 0.586449 13.0953 3.66762 15.6951 7.19465C18.5 11 18.7464 16.0653 15.3639 19.4007L0 0L15.3639 19.4007C11.8492 22.8664 6.15075 22.8664 2.63604 19.4007L0 0L2.63604 19.4007C-0.746466 16.0653 -0.499994 11 2.3049 7.19464C4.90464 3.66762 8.23558 0.586461 8.70893 0.154608Z"
    //     fill="#479683"
    //   />
    // </svg>,
    <svg
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6038 3.38239L9 0L6.39623 3.38239C2.69523 4.49911 0 7.9348 0 12C0 16.9706 4.02944 21 9 21C13.9706 21 18 16.9706 18 12C18 7.9348 15.3048 4.49911 11.6038 3.38239Z"
        fill="#479683"
      />
    </svg>,

    "HighlightIcon"
  );

  return (
    // <SvgIcon
    //   sx={{ width: "18px", height: "22px" }}
    //   color={"primary"}
    //   inheritViewBox
    // >
    <LogoIcon />
    // </SvgIcon>
  );
}
